/**
 * 워크스페이스 문서의 `labs` 배열 — 그 워크스페이스에만 여는 실험 기능의 스위치.
 *
 * 🔑 배열에 값이 **있을 때만** 연다 — 플랜과 상관없다(플랜 관문은 따로 선다).
 * ⚠️ 값은 운영자가 워크스페이스 문서에 손으로 넣는다 — 글자가 하나라도 다르면 꺼진 것과 같다.
 */

/** 컨텐츠 분석(Labs) — 이 값이 `labs` 에 있는 워크스페이스에만 메뉴와 화면이 선다 */
export const LAB_POST_ANALYSIS = 'multimodalAnalysis';

/** 채널 성과 모니터링(Labs) — 이 값이 `labs` 에 있는 워크스페이스에만 메뉴·화면과 Windsor 심화 연동(추적 관리 ⋯ 「심화 연동」 포함)이 선다 */
export const LAB_SNS_PERFORMANCE = 'sns-performance';

/**
 * @param labs 워크스페이스 문서의 `labs`(문자열 배열 — 없거나 모양이 다르면 꺼짐)
 * @param name 실험 기능의 값(`LAB_*`)
 * @returns 그 값이 배열에 있으면 `true`
 */
export function hasWorkspaceLab(labs: unknown, name: string): boolean {
  return Array.isArray(labs) && labs.some((lab) => typeof lab === 'string' && lab.trim() === name);
}
